/**
* Nom : targetDetails.js
* Description : Ce fichier contient la définition de la page targetDetails 
*               Cette page affiche les informations détaillées d'une cible
* Date de création : 23 septembre 2024
*/

/* CSS et assets */
import { EditIcon } from 'package_ui_ihm/dist'
import { DeleteIcon } from 'package_ui_ihm/dist'

/* Bibliothèques et composants */
import { TabRD } from 'package_ui_ihm/dist'
import { Container } from 'package_ui_ihm/dist'
import { Table} from 'package_ui_ihm/dist'
import { AddItem } from 'package_ui_ihm/dist'
import { GotoPage } from 'package_ui_ihm/dist'
import { BackPage } from 'package_ui_ihm/dist'
import { Image } from 'package_ui_ihm/dist'
import { Link } from 'react-router-dom'

/* Hook */
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useScreenWidth } from 'package_ui_ihm/dist'


/**
* TargetDetails : affiche la page qui contient les informations détaillées d'une cible
*                 plusieurs liens permettent de naviguer sur d'autres pages
*
* Type : page 
*
* Parametres : 
*  None
*/
function TargetDetails() {

  //Define useParam
  const { id } = useParams()


  // Define useState hooks
  const [target, setTarget] = useState(null)
  const [statusTarget, setStatusTarget] = useState(null)
  const [isDataLoading, setDataLoading] = useState(false)


  // Define useContext hooks
  const { authStatus, authToken, currentUser } = useAuth();
  const { path } = useApi();


  // Define useScreenWidth hooks
  const screenWidth = useScreenWidth();


  // Define functions
  async function retrieveData() {
    // Token
    const token = "Bearer " + authToken
    // Retrieve target details
    const response = await fetch(path + "/api/bo-taet/" + id + "/", 
      {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers: {
            accept: 'application/json',
            Authorization: token,
        },
      }
    );
    const data = await response.json();
    setStatusTarget(response["status"])
    setTarget(data)
    // Dataloading
    setDataLoading(false)
  }


  // Define useEffect hooks
  useEffect(() => {
    if(authStatus === 200)
    {
      setDataLoading(true)
      retrieveData()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  // Render component
  return (
    <div>
      <TabRD tabNumber={1}/>
      <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
        <Container>
          {isDataLoading ? (
            <p>Chargement des données</p>
          ) : (
            (statusTarget === 200) ? (
              <div>
                {/*Titre et icones*/}
                <div className={(screenWidth > 650) ? 'flex-row' : null}>
                  <h1>{target["name"]}</h1>
                  <div className='flex-row'>
                    <Link to={'/targets/' + target["id"] + '/edit'} className='link link-icon'>
                          <img src={EditIcon} alt='edit_item_icon' className='link-img' />
                    </Link>
                    { (currentUser["role_name"] === "AT_ADMIN") ? (
                        <Link to={'/targets/' + target["id"] + '/delete'} className='link link-icon'>
                            <img src={DeleteIcon} alt='delete_item_icon' className='link-img' />
                        </Link>
                      ) : (
                        <p></p>
                      )
                    }
                  </div>
                </div>
                {/*Liens*/}
                <div className='flex-row justify-center margin-bottom margin-top'>
                  <div className='link-border'>
                    <BackPage path='/targets'>Retour à la liste des cibles</BackPage>
                  </div>
                  <div className='link-border'>
                    <AddItem path={'/trials/new/' + id}>Créer un nouvel essai pour cette cible</AddItem>
                  </div>
                  <div className='link-border'>
                    <GotoPage path={'/trials/' + target.category.id + '/' + target.variety.id + '/' + target.target_type.id}>Essais associés à la cible</GotoPage>
                  </div>
                </div>
                {/*Photo et information*/}
                <div className={(screenWidth > 650) ? 'grid-1-1-1 margin-bottom' : 'margin-bottom'}>
                  <Image url={target["url_image"]}/>
                  <Table labels={['Catégorie', 'Varieté', 'Type de cible', "Plage d'hormèse"]} datas={[target["category"]["name"], target["variety"]["name"], target["target_type"]["name"], target["hormesis_min"] + " mJ/cm² - " + target["hormesis_max"] + " mJ/cm²"]}/>
                  <div/>
                </div>
              </div>
            ) : (
              <div>
                <p>Aucune cible actuellement. Veuillez en créer une !</p>
                {/*Lien de retour*/}
                <div className='flex-row justify-start margin-left margin-bottom margin-top'>
                    <div className='link-border'>
                        <BackPage path='/targets'>Retour à la liste des cibles</BackPage>
                    </div>
                </div>
              </div>
            )
          )}
        </Container>
      </div>
    </div>
  );
}

export default TargetDetails;
